<div class="chat-name-container">
  @if (hasMembers()) {
    <input
      type="text"
      class="chat-name-input"
      data-cy="ChatForm:conversationNameInput"
      [placeholder]="placeholder()"
      [formControl]="chatNameFormControl"
    />
  }

  <div class="flex-1"></div>

  <div class="flex gap-16 items-center justify-start">
    @if (hasMembers()) {
      <button
        type="button"
        class="chat-start-button"
        data-cy="ChatForm:save"
        [disabled]="selectedMembers().length === 0"
        (click)="saveChat()"
      >
        {{ conversation() ? 'Save' : 'Start' }}
      </button>
    }
    <button type="button" class="chat-cancel-button" (click)="closeChat()"> Cancel </button>
  </div>
</div>

@if (hasMembers()) {
  <div class="flex flex-col w-full h-full pb-[40px]">
    <div class="py-8 w-full min-h-[40px] text-16 flex items-center justify-start">
      <mat-chip-grid #chipList class="bd-chips">
        @for (member of selectedMembers(); track member.id) {
          <mat-chip-row
            class="selected-member-chip"
            [value]="member"
            (removed)="removeSelection(member)"
          >
            {{ member.name }}
            <button matChipRemove>
              <mat-icon svgIcon="icon_close_16" />
            </button>
          </mat-chip-row>
        }

        <input
          #textInput
          class="outline-none"
          role="combobox"
          aria-autocomplete="list"
          aria-expanded="true"
          [attr.aria-controls]="listBoxId"
          [attr.aria-activedescendant]="
            filteredMembers().length ? 'member-option-' + selectedOptionIndex() : null
          "
          [placeholder]="selectedMembers().length ? '' : 'To: '"
          [matChipInputFor]="chipList"
          [formControl]="searchFormControl"
          (keydown.arrowDown)="focusNextOption()"
          (keydown.arrowUp)="focusPreviousOption()"
          (keydown.enter)="onSelect()"
        />
      </mat-chip-grid>
    </div>

    <blaze-scroller class="members-list">
      <div [id]="listBoxId" role="listbox">
        @for (member of filteredMembers(); track member.id; let i = $index) {
          <be-chat-list-item
            class="chat-member"
            role="option"
            tabindex="-1"
            data-cy="ChatForm:member"
            [id]="'member-option-' + i"
            [isSelected]="selectedOptionIndex() === i"
            [attr.aria-selected]="selectedOptionIndex() === i"
            [title]="member.name ?? ''"
            [imageSrc]="member.image"
            [colorInfo]="membersColors()[member.email || '']"
            [status]="[member]"
            [participantCount]="1"
            (click)="onSelect(i)"
          />
        }
      </div>
    </blaze-scroller>
  </div>
} @else {
  <div class="flex w-full h-full items-center justify-center">
    <div class="flex flex-col items-center justify-center p-16 bg-bat-fill rounded gap-16">
      <div class="flex flex-col w-full gap-4 items-center justify-center">
        <mat-icon svgIcon="icon_warning_24" class="text-bat-title" style="--icon-size: 24px" />
        <div class="font-medium text-16 text-bat-title text-center w-full leading-5"
          >No users available yet</div
        >
      </div>
      @if (membersTableName()) {
        <div class="text-bat-value text-13 text-center w-full">
          To start a conversation, please add members to the
          <span class="text-bat-accent">{{ membersTableName() }}</span> table first.
        </div>
      }
    </div>
  </div>
}
